@if (config$ | async; as config) {
    <sh-search-page [config]="config" (columnSelectionChanged)="onColumnSelectionChanged($event)">
        @if (config$ | async; as config) {
            <sh-profile-facet-list
                filtersContent class="sh-page-section--full"
                [facetProfile]="facetProfile$ | async"
                [queryRestrictions]="queryRestrictions"
                [facetRefreshTriggers]="config.search.refreshTriggers"
            >
            </sh-profile-facet-list>
        }

        @if ($pimFeatureEnabled()) {
            <sh-record-tree-panel hierarchyContent class="sh-page-section--full"></sh-record-tree-panel>
        }

        <ng-content abovePageHeader select="[abovePageHeader]"></ng-content>

        <ng-content belowPageHeader select="[belowPageHeader]"></ng-content>

        <ng-content detailContent select="[detailContent]"></ng-content>
    </sh-search-page>

    <router-outlet name="preview"></router-outlet>
}
